export function isHexColor(color) {
    return typeof color === 'string' && color[0] === '#';
}
